/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateUpdatePresentationViewCommand } from '../model/createUpdatePresentationViewCommand';
import { CreateUpdatePresentationViewCommandResult } from '../model/createUpdatePresentationViewCommandResult';
import { DeletePresentationViewCommandResult } from '../model/deletePresentationViewCommandResult';
import { GetPresentationViewQueryResult } from '../model/getPresentationViewQueryResult';
import { GetPresentationViewsQueryResult } from '../model/getPresentationViewsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PresentationViewsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [PORTAL] Creates or updates a presentation view
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public presentationViewsCreateUpdatePost(body?: CreateUpdatePresentationViewCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateUpdatePresentationViewCommandResult>;
    public presentationViewsCreateUpdatePost(body?: CreateUpdatePresentationViewCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateUpdatePresentationViewCommandResult>>;
    public presentationViewsCreateUpdatePost(body?: CreateUpdatePresentationViewCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateUpdatePresentationViewCommandResult>>;
    public presentationViewsCreateUpdatePost(body?: CreateUpdatePresentationViewCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateUpdatePresentationViewCommandResult>('post',`${this.basePath}/PresentationViews/CreateUpdate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets the presentation views for an assignment
     * 
     * @param userAssessmentUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public presentationViewsGet(userAssessmentUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetPresentationViewsQueryResult>;
    public presentationViewsGet(userAssessmentUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPresentationViewsQueryResult>>;
    public presentationViewsGet(userAssessmentUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPresentationViewsQueryResult>>;
    public presentationViewsGet(userAssessmentUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userAssessmentUid !== undefined && userAssessmentUid !== null) {
            queryParameters = queryParameters.set('UserAssessmentUid', <any>userAssessmentUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPresentationViewsQueryResult>('get',`${this.basePath}/PresentationViews`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Deletes a presentation view
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public presentationViewsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeletePresentationViewCommandResult>;
    public presentationViewsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeletePresentationViewCommandResult>>;
    public presentationViewsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeletePresentationViewCommandResult>>;
    public presentationViewsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling presentationViewsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeletePresentationViewCommandResult>('delete',`${this.basePath}/PresentationViews/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [PORTAL] Gets a single presentation view
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public presentationViewsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetPresentationViewQueryResult>;
    public presentationViewsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPresentationViewQueryResult>>;
    public presentationViewsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPresentationViewQueryResult>>;
    public presentationViewsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling presentationViewsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPresentationViewQueryResult>('get',`${this.basePath}/PresentationViews/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
